import { takeEvery } from 'redux-saga/effects';
import { Types } from 'store/ducks/city';
import { getCitiesByName } from './city';

const citiesSagas = [
	takeEvery(Types.FETCH_CITIES_BY_NAME, getCitiesByName)
]

export default citiesSagas;